import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('screenUsageStore', Object.keys(state)),
	...mapGetters('screenUsageStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('screenUsageStore', Object.keys(actions)),
	...mapMutations('screenUsageStore', Object.keys(mutations))
};
